const newsDetailList = [
    {
        id: 1,
        pid: 1,
        title: '欧盟《净零工业法案》通过！要求40%光伏组件由本土制造',
        desc: '《净零工业法案》是欧盟绿色协议工业计划的关键部分，旨在确保到2030年欧盟...',
        date: '2024-06',
        day:'26',
        url: '/news/1',
        content: '<p>当地时间5月27日，欧盟通过《净零工业法案》。法案旨在加速欧盟向气候中和转型的进程，同时提升欧盟的工业竞争力等。</p>\n' +
            '<p>据悉，2023年3月16日，欧盟委员会发布《净零工业法案》和《关键原材料法案》提案，旨在确保欧盟在全球绿色工业技术方面处于领先地位。</p>\n' +
            '<p>《净零工业法案》是欧盟绿色协议工业计划的关键部分，旨在确保到2030年欧盟至少40%的包括风力涡轮机、电池、热泵、太阳能电池板、可再生氢等在内的清洁技术需求在欧洲本土制造。净零工业法案将通过增强信息、减轻建立项目的行政负担和简化许可授予程序来改善净零技术投资的条件。为了促进净零排放技术供应的多样化，法案要求公共当局在公共采购或拍卖中考虑净零排放技术的可持续性和弹性标准。</p>\n' +
            '<p>而事实上，有数据显示目前欧盟本土生产的太阳能组件仅占市场的3%，欧盟的光伏装机大量依赖中国进口。最新海关数据显示，今年三月，中国共出口约24.5GW的光伏组件，全球前三大进口中国光伏组件市场依序为欧洲、巴基斯坦与沙特，三者单月进口总量约占全球市场60%，其中欧洲市场从中国进口约9.7GW的光伏组件，相比二月的8GW环比上升21%。</p>'
    },
    {
        id: 2,
        pid: 1,
        title: '2024年3月欧盟工业生产增长0.2%',
        desc: '欧盟统计局5月15日发布初估数据显示，经季节调整后，2024年3月欧盟工业生产环比增长0.2%...',
        date: '2024-06',
        day:'26',
        url: '/news/2',
        content: '<p>欧盟统计局5月15日发布初估数据显示，经季节调整后，2024年3月欧盟工业生产环比增长0.2%，欧元区工业生产环比增长0.6%。 与去年同期相比，欧盟和欧元区工业生产数据均下降1.0%。</p>\n' +
            '\n' +
            '<p>从主要工业分组看，与2024年2月相比，2024年3月欧盟工业生产的中间产品下降0.5%，能源减少0.2%，资本货物增长0.7%，耐用消费品下降1.0%，非耐用消费品下降2.7%。月度增幅最高的是爱尔兰（12.8%）、比利时（6.8%）和卢森堡（4.5%）。降幅最大的是斯洛文尼亚（-5.9%）、波兰（-5.1%）和丹麦（-4.3%）。两大经济体德国和法国3月份工业生产较2月份分别下降0.7%和0.3%。</p>'
    }
]
export function getNewsLeftMenuList() {
    const newsLeftMenuList = [
        {
            id: 1,
            title: '行业动态',
            url: '/news/index?nId=1&pageNo=1'
        },
    ]
    return newsLeftMenuList
}

export function getNewsDetailPage(pageNo,pageSize,mId) {
    let totalNum = newsDetailList.length
    let pageObj = calculatePagination(pageNo, pageSize, totalNum)
    let list = getNewsListByNo(pageObj.startNo, pageObj.endNo, mId)
    pageObj.data = list
    return pageObj
}

function getNewsListByNo(start, end,mId) {
    let list = []
    let dataSourceList = []
    for (let news of newsDetailList) {
        if(mId == news.pid){
            dataSourceList.push(news)
        }
    }
    for (let i = 1; i <= dataSourceList.length; i++) {
        if(start <= i && i <= end){
            list.push(dataSourceList[i-1])
        }
    }
    return list
}

export function getNewsDetailById(ndId) {
    let resultObj = {}
    for (let i = 0; i < newsDetailList.length; i++) {
        let obj = newsDetailList[i]
        if(obj.id == ndId){
            resultObj = obj
            break
        }
    }
    return resultObj
}

// 计算分页
export function calculatePagination(currentPage, pageSize, totalItems) {
    // 计算总页数
    const totalPages = Math.ceil(totalItems / pageSize);

    // 计算起始和结束的页码
    const startPage = Math.max(1, currentPage - 1);
    const endPage = Math.min(totalPages, currentPage + 1);

    // 计算左侧和右侧的数据编号
    const boundaryPages = 2;
    let leftBoundary = Math.max(1, startPage - boundaryPages);
    let rightBoundary = Math.min(totalPages, endPage + boundaryPages);

    // 如果左侧边界小于1，右侧边界需要相应减少
    if (leftBoundary < 1) {
        rightBoundary = Math.min(totalPages, rightBoundary + (1 - leftBoundary));
        leftBoundary = 1;
    }

    // 如果右侧边界大于总页数，左侧边界需要相应增加
    if (rightBoundary > totalPages) {
        leftBoundary = Math.max(1, leftBoundary - (rightBoundary - totalPages));
        rightBoundary = totalPages;
    }

    let startNo = 1
    if(leftBoundary <= 1){
        startNo = 1
    } else{
        startNo = parseInt((leftBoundary - 1) * pageSize)
    }
    let endNo = parseInt(leftBoundary * pageSize)

    // 生成页码数组
    const pages = Array.from({ length: rightBoundary - leftBoundary + 1 }, (v, k) => leftBoundary + k);

    return {
        totalPages: totalPages,
        startPage: startPage,
        endPage: endPage,
        leftBoundary: leftBoundary,
        rightBoundary: rightBoundary,
        startNo: startNo,
        endNo: endNo,
        pages: pages,
        pageSize: pageSize
    };
}
